export default {
  validate (propertyRebuildCost) {
    const min = this.constants.PROPERTY_REBUILD_COST_MIN;
    const max = this.constants.PROPERTY_REBUILD_COST_MAX;
    if (!propertyRebuildCost) {
      return 'Please enter a rebuild cost for your property.';
    }
    if (Number(propertyRebuildCost) < Number(min) || Number(propertyRebuildCost) > Number(max)) {
      return `The rebuild cost should be between £${min} & £${max}.`;
    }
    return true;
  },
  computesRequired: true,
};
